import { usnCompare } from "../pages/rateCompare/compare";

export const getPTC = async (zipcode, utilityId) => {
  return await usnCompare(zipcode, utilityId);
};
